import { Component } from '@angular/core';
import { CoverageMapWidgetComponent } from '../widgets/coverage-map-widget/coverage-map-widget.component';
import { CoverageTableWidgetComponent } from '../widgets/coverage-table-widget/coverage-table-widget.component';
import { CoverageOverviewWidgetComponent } from '../widgets/coverage-overview-widget/coverage-overview-widget.component';

@Component({
  selector: 'tgrid-outage-data-page',
  templateUrl: './outage-data-page.component.html',
  styleUrls: ['./outage-data-page.component.scss'],
  imports: [CoverageMapWidgetComponent, CoverageTableWidgetComponent, CoverageOverviewWidgetComponent],
})
export class OutageDataPageComponent {
}
